<template>
  <div class="annotation-audit-log-panel">
    <annotation-audit-log-list v-if="image" :image="image.id" :index="index" panel-layout :show-title="false" />
  </div>
</template>

<script>
import AnnotationAuditLogList from '@/components/annotations/AnnotationAuditLogList';
import viewerImageContext from '../mixins/viewer-image-context';

export default {
  name: 'annotation-audit-log-panel',
  mixins: [viewerImageContext],
  components: {
    AnnotationAuditLogList
  },
  props: {
    index: String
  }
};
</script>

<style scoped lang="scss">
.annotation-audit-log-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
}
</style>
